import { IconProps } from "./";
import Icon from "./assets/user_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24User(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
